import React from "react";
import { Card, Typography, Button, Avatar, Grid, Box } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import color from "../utils/Colors";
import { useNavigate } from "react-router-dom";

interface Course {
  id?: number;
  image: string;
  title: string;
  duration: string;
}

interface User {
  name: string;
  email: string;
  phone: string;
  isVerified: boolean;
  courses: Course[];
}

interface AdminCourseCardProps {
  user: User;
}

const AdminCourseCard: React.FC<AdminCourseCardProps> = ({ user }) => {
  const navigate = useNavigate();
  return (
    <Card
      style={{
        borderRadius: 15,
        border: "2px solid",
        background: "#f9f9f9",
        borderColor: "#92899d",
        boxShadow: "none",
        padding: "20px",
        width: 380,
      }}
    >
      <Grid container spacing={2} alignItems="center" sx={{ display: "flex" }}>
        <Grid item>
          <Avatar
            sx={{
              width: 80,
              height: 80,
              color: color.forthColor,
              background: color.secondColor,
            }}
          />
        </Grid>
        <Grid item xs>
          <Typography
            variant="h5"
            component="div"
            style={{ fontWeight: 600, color: color.textColor }}
          >
            {user.name}
          </Typography>
          <Typography fontSize="12px" sx={{ color: color.textColor }}>
            {user.email}
          </Typography>
          <Typography fontSize="12px" sx={{ color: color.textColor }}>
            {user.phone}
          </Typography>
        </Grid>
        <Grid item>
          {user.isVerified ? (
            <Button
              startIcon={<CheckCircleIcon color="success" />}
              color="success"
            >
              Verified
            </Button>
          ) : (
            <Button startIcon={<CancelIcon color="error" />} color="error">
              Not Verified
            </Button>
          )}
        </Grid>
      </Grid>
      <hr style={{ margin: "15px 0" }} />
      <Grid
        container
        spacing={2}
        alignItems="center"
        mt={1}
        mb={2}
        p={2}
        pb={1}
        pt={1}
        sx={{
          height: "219px",
          overflowY: "auto",
          "&::-webkit-scrollbar": {
            width: "6px",
            height: "20px",
          },
          "&::-webkit-scrollbar-track": {
            background: color.secondColor,
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: color.firstColor,
            border: "solid 1px white",
            borderRadius: "10px",
          },
        }}
      >
        {user.courses.map((course) => (
          <Grid
            container
            key={course.id ?? course.title}
            style={{ marginBottom: 15, alignItems: "center" }}
          >
            <Grid
              item
              xs={4}
              sm={3.5}
              sx={{ alignItems: "center", display: "flex" }}
            >
              <img
                src={course.image}
                alt="course"
                style={{ width: 75, height: 50, borderRadius: 5 }}
              />
            </Grid>
            <Grid item xs={6} sm={6.5}>
              <Typography
              onClick={() => {
                navigate("/courses-details-admin", {
                  state: { courseId: course.id },
                });
              }}
                variant="h6"
                style={{ color: color.textColor, cursor: "pointer" }}
                sx={{
                    '&:hover':{
                        textDecoration:'underline'
                    }
                }}
              >
                {course.title}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body2" color="textSecondary">
                {course.duration}
              </Typography>
            </Grid>
          </Grid>
        ))}
      </Grid>
      {/* <hr /> */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ cursor: "pointer" }}
          sx={{ textDecoration: "underline" }}
        >
          Send Feedback on mail
        </Typography>

        <Button
          id="button1"
          variant="contained"
          color="primary"
          //   style={{ marginTop: 10 }}
        >
          Publish
        </Button>
      </Box>
    </Card>
  );
};

export default AdminCourseCard;
